<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="container my-5 d-body">
  <div>
    <div class="container assign-course">
      <div class="row assign-nav">
        <div class="col-lg-1 col-sm-12"></div>
        <div class="col-lg-10 col-sm-12">
          <ul class="nav nav-pills mb-3 justify-content-center mt-5">
            <li class="nav- click">
              <a class="nav-link " routerLink="/assignCourse/selectCourse">
                <span class="number">1</span> Select Participants</a
              >
            </li>
            <li class="nav-item click">
              <a class="nav-link " routerLink="/assignCourse/selectParticipant">
                <span class="number">2</span> Select Courses/Paths</a
              >
            </li>
            <li class="nav-item click">
              <a class="nav-link active" routerLink="/assignCourse/chooseDate"
                ><span class="number">3</span>Choose Dates</a
              >
            </li>
            <li class="nav-item click">
              <a class="nav-link" routerLink="/assignCourse/confirmation"
                ><span class="number">4</span>Confirmation</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-sm-12">
          <p class="font-light font18 mt-4 p">
            Please select the due date for the assigned course(s)
          </p>
        </div>
        <div class="col-lg-9 col-sm-12 sm-mt">
          <div class="bg-white px-5 py-3">
            <div class="row">
              <div class="col-lg-6 col-sm-12">
                <p class="font16 mt-2">Choose Due Date</p>
                <div class="my-4 d-flex justify-content-center">
                  <div class="">
                    <bs-datepicker-inline
                      [minDate]="today"
                      (bsValueChange)="onDueDateChange($event)"
                    ></bs-datepicker-inline>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="my-5 d-flex justify-content-end">
            <button class="btn btn-secondary" (click)="assign()">Assign</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-auto">
    <hr />
    <iq-central-front-end-footer></iq-central-front-end-footer>
  </div>
</section>
